import React, { Component } from 'react';

class GoogleAds extends Component {

    componentDidMount() {
        (window.adsbygoogle = window.adsbygoogle || []).push({});    }

    render() {
        return (
                <ins className='adsbygoogle'
                
                style={{ display: 'block' }} 
                
                data-ad-client= 'ca-pub-9058298844141347' 
                
                data-ad-slot={this.props.slot}                   
                
                data-ad-format= 'auto'                    
                
                data-full-width-responsive="true"
                
                data-adtest="on"
                
                >               
                
                 </ins>
        );
    }
}

export default GoogleAds;